import React from 'react';
import { SpinnerWrapper as EmotionSpinnerWrapper } from './styled-emotion';
import { SpinnerWrapper as CompiledSpinnerWrapper } from './styled-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var SpinnerWrapper = function SpinnerWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledSpinnerWrapper, props) : /*#__PURE__*/React.createElement(EmotionSpinnerWrapper, props);
};